import * as React from "react";
import { AddCircle20Regular, Dismiss20Regular } from "@fluentui/react-icons";
import { hideModal, showModal, updateComment } from "../../../redux/reducers/ModalReducer";
import {
    addArtistToWork, setDataSource, addWorkToProduct, addArtistToProduct, updateRelatedWork, updateWorkSourceIP, updateEditableFields,
    addMatchWorkToUsage, addMatchProductToUsage, searchDataChanged, updateSelectionCriteria, updateForeignSocietyInfo, addIPToAdjustmentDetails, addWorkOrProductToUsageSearchCriteria, addWorkToLicenseRequest, addIPToUsageDetails, updateProductSourceIP, addWorkToClaimRequest, updateScheduledJobField,
    updateRepresentationSelector,
    addArtistToUsage,
    updateTerritorySelector,
    addVenueToUsage,
    addLicenseVenueToUsage
} from "../../../redux/reducers/RepertoireReducer";
import CommentsView from "../modalViews/commentsView/CommentsView";
import {
    COMMENTS_VIEW,
    SEARCH_VIEW,
    WORK_NOT_FOUND_VIEW,
    LOADING_VIEW,
    YES_NO_PROMPT_VIEW,
    VERSION_HISTORY_VIEW,
    PRODUCT_WORKS_KEY,
    INTRAY,
    REPERTOIRE,
    WORK_SUBMISSION_VIEW,
    COMPONENTS_KEY,
    FIELD_SETTING_VIEW,
    SEARCH_VIEW_PRODUCTS,
    MESSAGE_VIEW,
    ASSING_WORKFLOW_VIEW,
    UPDATE_WORKFLOW_VIEW,
    USAGESEARCH_VIEW,
    SPLIT_LICENSE_VIEW,
    CONTRIBUTORS_SEARCH_VIEW,
    SELECTION_CRITERIA_VIEW,
    DISTRIBUTION_VERSION_HISTORY_VIEW,
    IMPORT_DATA_VIEW,
    FOREIGN_SOCIETY_INFO_VIEW,
    MATCHING_WORK_MORE_INFO_VIEW,
    SEARCH_VIEW_USAGES,
    IP_TRANSFER_VIEW,
    WORK_MAINTENANCE_TOOLBAR,
    DATA_SOURCE,
    WORK_SEARCH_VIEW,
    REJECT_UP_WORKFLOW,
    SCHEDULED_JOB_MODAL_VIEW,
    SHORTCUT_KEY_MODAL,
    JOBS_IN_PROGRESS_MODAL,
    REPERTOIRE_PAGE_JOBS,
    IMPORT_POOL_DATA_VIEW_DISTRIBUTIONS,
    TERRITORY_SELECTION_VIEW,
    APPLICABLE_WORKS_KEY,
    POOL_SELECTION_VIEW,
    AGREEMENTS_APPLICABLE_WORKS_SEARCH,
    USAGE_MAINTENANCE_COMMENTS_MODAL,
    CONTRIBUTORS_KEY,
    IMPORT_WEIGHTS_DATA_VIEW_POOL,
    SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT,
    SEARCH_VIEW_USAGES_USAGE_TO_WORK,
    JOB_CREATED_VIEW,
    USAGE_PAGE_VIEW,
    USAGE_ROWS_SECTION_KEY,
    IMPORT_WEIGHTS_CODES_DATA_VIEW_POOL,
    ADD_WORKS_FROM_PACKAGE_VIEW,
    SEARCH_VIEW_WORKS,
    EDIT_JOB_SCHEDULE_MODAL,
    USAGETOPRODUCT,
    USAGETOWORK,
    USAGE_TO_PRODUCT,
    USAGE_TO_WORK
} from "../../Consts";
import { DataSource } from "../../types/DataSource";
import { IArtist } from "../../types/IArtist";
import { IArtistSearchQuery } from "../../types/IArtistSearchQuery";
import { IContributorItem } from "../../types/IContributorItem";
import { IContributorSearchQuery } from "../../types/IContributorSearchQuery";
import { IContributorSearchResult } from "../../types/IContributorSearchResult";
import { IP } from "../../types/IP";
import { IWorksSearchQuery } from "../../types/IWorksSearchQuery";
import { IWorksSearchResult } from "../../types/IWorksSearchResult";
import AssingWorkflowTo from "../assingWorkflow/AssingWorkflowView";
import FieldSettingView from "../modalViews/fieldSettingView/FieldSettingView";
import LoadingView from "../modalViews/loadingView/LoadingView";
import PopUpInfo from "../modalViews/popUpInfo/PopUpInfo";
import VersionHistoryView from "../modalViews/versionHistoryView/VersionHistoryView";
import WorkNotFoundView from "../modalViews/workNotFoundView/WorkNotFoundView";
import SubmissionPromptView from "../modalViews/workSubmission/WorkSubmission";
import YesNoPromptView from "../modalViews/yesNoPromptView/YesNoPromptView";
import SearchView from "../searchView/SearchView";
import SelectorView from "../selectorView/SelectorView";
import UpdateWorkflowView from "../updateWorkflow/UpdateWorkflowView";
import UsageSearchView from "../usageComponents/searchView/UsageSearchView";
import SplitLicenseView from "../../usage/components/usageMaintenanceGridsView/usageMaintenanceGridMatchingLicense/SplitLicenseView";
import { IUsagesSearchQuery } from "../../types/usageTypes/IUsagesSearchQuery";
import { IUsageGroupResult } from "../../types/usageTypes/IUsageGroupsSearchResult";
import { IMatchWorksSearchQuery } from "../../types/usageTypes/IMatchWorksSearchQuery";
import { IMatchWorksSearchResult } from "../../types/usageTypes/IMatchWorksSearchResult";
import IRepertoireComponentDataItem from "../../../redux/types/IRepertoireComponentDataItem";
import { IMatchProductsSearchQuery } from "../../types/usageTypes/IMatchProductsSearchQuery";
import { IProductSearchResult } from "../../types/IProductSearchResult";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { ITreeData } from "../../types/ITreeData";
import SelectionCriteriaView from "../modalViews/selectionCriteriaView/SelectionCriteriaView";
import { ISelectionCriteria } from "../../types/ISelectionCriteria";
import { IDistribution } from "../../types/usageTypes/IDistribution";
import { IImportViewProps, ImportView } from "../modalViews/importView/ImportView";
import { addFileToUpload, fileMetadataChanged, setInDropZone, setProgressUploadFileProccess, sortColumn } from "../../../redux/reducers/DataIngestionReducer";
import { IComponentDataItem } from "../../../core/types/IComponentDataItem";
import IDroppedFiles from "../../../redux/types/IDroppedFiles";
import { IDistributionState } from "../../../redux/types/IDistributionState";
import { ITabReduxItem } from "../../../redux/types/ITabReduxItem";
import ForeignSocietyInfoView from "../modalViews/foreignSocietyInfoView/ForeignSocietyInfoView";
import { getMatchingWorkInfo } from "../../../redux/thunks/RepertoireThunks";
import { IDistributionType } from "../../types/usageTypes/IDistibutionType";
import { IpTransferView } from "../modalViews/ipTransferView/IpTransferView";
import { IIPsSearchQuery } from "../../types/IIPsSearchQuery";
import { IipTransfer } from "../../types/usageTypes/IipTransfer";
import { ILicenseUserSearchQuery } from "../../types/ILicenseUserSearchQuery";
import { ILicenseUserSearchResult } from "../../types/ILicenseUserSearchResult";
import { IProductSearchQuery } from "../../types/IProductSearchQuery";
import { IDataActionToolbar } from "../../types/IDataActionToolbar";
import { FormatFields } from "../../../redux/types/FormatFields";
import { getDataAction } from "../toolBar/ToolbarHelper";
import ProductWorkSearchModalViewContainer from "../modalViews/productWorkSearchView/ProductWorkSearchModalContainer";
import UsageWorkSearchModalContainer from "../modalViews/usageWorkSearchView/UsageWorkSearchModalContainer";
import UsageProductSearchModalViewContainer from "../modalViews/usageProductSearchModalView/UsageProductSearchModalViewContainer";
import { SearchRequests } from "../../services/SearchRequests";
import { WORK_MAINTENANCE_GROUP } from "../../../membersportal/ConfigurationConsts";
import { CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY } from "../../ConfigurationConsts";
import RejectWorkflowView from "../modalViews/rejectWorkflowView/RejectWorkflowView";
import { IWorkSubjectSearchResult } from "../../types/IWorkSubjectSearchResult";
import { ISubjectsSearchQuery } from "../../types/ISubjectsSearchQuery";
import { ISubject } from "../../types/ISubject";
import ScheduledJobModalView from "../modalViews/scheduledJobModalView/ScheduledJobModalView";
import ShortcutKeyModalView from "../shortcutKeyModalView/ShortcutKeyModalView";
import JobsInProgressModal from "../jobsInProgressModal/JobsInProgressModal";
import TerritorySelectionView from "../modalViews/territorySelectionView/TerritorySelectionView";
import ActionButton from "../actionButton/ActionButton";
import PoolSelectionView from "../modalViews/poolSelectionView/PoolSelectionView";
import AgreementApplicableWorkSearchView from "../modalViews/agreementApplicableWorkSearchView/AgreementApplicableWorkSearchView";
import UsageMaintenanceGridCommentsModalView from "../../usage/components/usageMaintenanceGridsView/usageMaintenanceGridCommentsDataView/UsageMaintenanceGirdCommentsModalView";
import { IVenueSearchQuery } from "../../types/IVenueSearchQuery";
import { ICustomerVenue } from "../../types/ISetListVenue";
import { IUsagePoolState } from "../../../redux/types/IUsagePoolState";
import { IAttachedFile } from "../../../redux/types/IAttachedFile";
import UsageResultsFieldSettingView from "../modalViews/fieldSettingView/UsageResultsTableFieldSettingView";
import { IComponentView } from "../../../redux/types/ComponentView";
import JobCreatedView from "../modalViews/jobCreatedView/JobCreatedView";
import { ILicenseVenueSearchQuery } from "../../types/ILicenseVenueSearchQuery";
import {ILicenseCustomerVenue} from "../../types/ILicenseCustomerVenue";
import { IComponentViewsPreference } from "../../../redux/types/IComponentViewsPreference";
import UsageMaintenanceFieldSettingView from "../modalViews/fieldSettingView/UsageMaintenanceFieldSettingView";
import UsageMaintenanceDetailTableFieldSettingView from "../modalViews/fieldSettingView/UsageMaintenanceDetailTableFieldSettingView";
import { IComponentViewReduxStore } from "../../../redux/types/ComponentViewReduxStore";
import AddWorksFromPackageView from "../modalViews/addWorksFromPackageView/AddWorksFromPackageView";
import { IAgreementWorksFromPackageJobRequest } from "../../types/IAgreementWorksFromPackageJobRequest";
import { IAgreementWorksFromPackageJobResponse } from "../../types/IAgreementWorksFromPackageJobResponse";
import EditScheduledJobsModalView from "../modalViews/editScheduledJobsModalView/EditScheduledJobsModalView";
import { IUsageSearcResultConfiguration } from "../../types/usageTypes/IUsageSearcResultConfiguration";

export interface IRepertoireModalProps {
    showModal: typeof showModal;
    hideModal: typeof hideModal;
    updateModalComment?: typeof updateComment;
    addArtistToWork?: typeof addArtistToWork;
    addArtistToProduct?: typeof addArtistToProduct;
    addWorkToProduct?: typeof addWorkToProduct;
    addArtistToUsage?: typeof addArtistToUsage;
    updateWorkContributorIP?: (dataSource: DataSource, workContributor: IContributorItem, ip: IP, customer?: string) => void;
    updateProductContributorIP?: (productContributorID: number, ip: IP) => void;
    updateAgreementIP?: (agreementAdminIPID: number, ip: IP) => void;
    updateAgreementSourceIP?:(sourceIPID:number,ip:IP)=>void;
    updateAgreementWork?: (work: IWorksSearchResult) => void;
    updateAgreementCarveOutProduct?: (agreementProductWorkID: number, product: IProductSearchResult) => void;
    getProductDetails?: (dataSource: string, productCoreID: number, openNewTab?: boolean) => void;
    updateMatchingWork?: (workID: number, work: IWorksSearchResult) => void;
    updateMatchingProduct?: (productID: number, product: IProductSearchResult) => void;
    modalContent: string;
    modalComponentInstance: string;
    modalIndex?: number;
    modalProps: any;
    modalKey?:string;
    displayModalCloseButton: boolean;
    searchViewData: IRepertoireComponentDataItem;
    searchResultsTableData: IRepertoireComponentDataItem;
    workNotFoundViewData: IRepertoireComponentDataItem;
    loadingViewData: IRepertoireComponentDataItem;
    yesNoPromptViewData: IRepertoireComponentDataItem;
    dataGridTableData: IRepertoireComponentDataItem;
    dataSource?: string;
    setDataSource?: typeof setDataSource;
    agreementsDataSource?: string;
    productDataSource?: string;
    modalTitle: string;
    searchSubjects?: (query: ISubjectsSearchQuery, modalOpen: boolean) => void;
    updateSubjectCode?: (subject: ISubject) => void;
    searchArtists?: (query: IArtistSearchQuery, dataSource: string) => void;
    artistsSearchResults?: IArtist[],
    venuesSearchResults?: ICustomerVenue[],
    licenseVenuesSearchResult?: ILicenseCustomerVenue[];
    contributorsSearchResults?: IContributorSearchResult[],
    searchContributors?: (
        query: IContributorSearchQuery
    ) => void;
    searchWorks?: (query: IWorksSearchQuery, modalOpen: boolean) => void;
    searchProducts?: (query: IProductSearchQuery, modalOpen: boolean) => void;
    worksSearchResults?: IWorksSearchResult[];
    productSearchResults?: IProductSearchResult[];
    searchSuccessful: boolean;
    updateRelatedWork?: typeof updateRelatedWork;
    updateWorkSourceIP?: typeof updateWorkSourceIP;
    updateProductSourceIP?: typeof updateProductSourceIP;
    componentInstance?: string;
    editableFields?: any;
    updateEditableFields?: typeof updateEditableFields;
    expandedWorkResults?: number[];
    expandedProductResults?: number[];
    expandAll?: boolean;
    expandWorkResult?: (workResult: number) => void;
    expandProductResult?: (productResult: number) => void;
    expandAllResults?: () => void;
    modalMessage: string;
    modalDetailMessage: string;
    updateWorkflowViewData?: IRepertoireComponentDataItem;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    usageSearchViewData?: IRepertoireComponentDataItem;
    usageSearchResultsTableData?: IRepertoireComponentDataItem;
    searchUsages?: (query: IUsagesSearchQuery, modalOpen: boolean, usageType: string, lookupSources: ITreeData[]) => void;
    usageGroupsSearchResult?: IUsageGroupResult[];
    searchMatchWorks?: (query: IMatchWorksSearchQuery, modalOpen: boolean) => void;
    matchWorkSearchResult?: IMatchWorksSearchResult[];
    usageExpandAllResults?: () => void;
    expandMatchWorkResult?: (matchWorkResults: number) => void;
    addMatchworkToUsage?: typeof addMatchWorkToUsage;
    addMatchProductToUsage?: typeof addMatchProductToUsage,
    expandedMatchWorkResults?: number[];
    usageExpandAll?: boolean,
    getUsageDetails?: (usageID: string, lookups: ILookupDictionary, openEntityForWorkflowSession?: boolean) => void;
    searchMatchProducts?: (query: IMatchProductsSearchQuery, modalOpen: boolean) => void;
    matchProductsSearchResult?: IProductSearchResult[];
    lookupValues: ILookupDictionary;
    searchDataChanged: typeof searchDataChanged;
    ipMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem;
    addNewAccount?: (lookupValues: ILookupDictionary, isNew?: boolean, ipMaintenanceGeneralDataView?: IRepertoireComponentDataItem) => void;
    addNewWork?: (lookups: ILookupDictionary, actionList: IDataActionToolbar[], isNew?: boolean, workMaintenanceGeneralDataView?: IRepertoireComponentDataItem, formats?: FormatFields[], workGroupId?: string, workGroup?: string) => void;
    lookupSources?: ITreeData[];
    usageSourceMajors?: { code: string; description: string; }[];
    usageSourceMinors?: { code: string; description: string; }[];
    usageDistributions?: { id: number; code: string; description: string; }[];
    usagePools?: { id: number; code: string; description: string; }[];
    selectionCriteria?: ISelectionCriteria;
    updateSelectionCriteria?: typeof updateSelectionCriteria;
    updateRepresentationSelector?: typeof updateRepresentationSelector;
    distributions?: IDistribution[];
    isReadOnlyModal?: boolean;
    droppedFiles?: IDroppedFiles;
    setInDropZone?: typeof setInDropZone;
    addFileToUpload?: typeof addFileToUpload;
    sortColumn: typeof sortColumn;
    isDropZone?: boolean;
    setProgressUploadFileProccess?: typeof setProgressUploadFileProccess;
    containerDetailsWindowComponentData?: IComponentDataItem;
    importDistributionPools?: (distribution: IDistributionState, file: string, lookupValues: ILookupDictionary) => void;
    importPoolWeightSettings?: (pool: IUsagePoolState, poolDimensionsAndDatesID: number, file: string) => void;
    importWeightSettingCodes?: (pool: IUsagePoolState, poolDimensionsAndDatesID: number, file: string) => void;
    tabs?: ITabReduxItem[];
    activeTab?: number;
    updateForeignSocietyInfo?: typeof updateForeignSocietyInfo;
    getMatchingWorkInfo?: typeof getMatchingWorkInfo;
    distributionTypes?: IDistributionType[];
    getDistributionTypes?: () => void;
    ipTransferViewData?: IRepertoireComponentDataItem;
    searchIPs?: (query: IIPsSearchQuery, keepModalOpenAfterSearch?: boolean) => void;
    ipTransfer?: (ipTransferObject: IipTransfer) => void;
    addIpToAdjustmentDetail?: typeof addIPToAdjustmentDetails;
    addIPToUsageDetails?: typeof addIPToUsageDetails;
    addWorkOrProductToUsageSearchCriteria?: typeof addWorkOrProductToUsageSearchCriteria;
    usageMatchingDefaultsWorks?: string[];
    usageMatchingDefaultsProducts?: string[];
    searchLicenseUser?: (query: ILicenseUserSearchQuery) => void;
    licenseUserSearchResults?: ILicenseUserSearchResult[];
    workSubjectSearchResults: IWorkSubjectSearchResult[];
    updateLicenceUserValues?: (params: any) => void;
    isRepertoireSearch?: boolean;
    addWorkToLicenseRequest?: typeof addWorkToLicenseRequest;
    addWorkToClaimRequest?: typeof addWorkToClaimRequest;
    commentCategoryFlag?: boolean;
    addNewProduct?: (lookups: ILookupDictionary, isNew?: boolean, productMaintenanceGeneralDataView?: IRepertoireComponentDataItem, formats?: FormatFields[]) => void;
    incrementTempID?: () => void;
    updateScheduledJobField?: typeof updateScheduledJobField;
    title?: string;
    customer?: string;
    updateUsageField?: any;
    getAllowFileSelectInSelectionCriteria: () => void;
    allowFileSelectInSelectionCriteria: boolean;
    updateTerritorySelector?: typeof updateTerritorySelector;
    searchVenues?: (query: IVenueSearchQuery, dataSource: any) => void;
    searchLicenseVenues?: (query: ILicenseVenueSearchQuery, dataSource: any) => void;
    addVenueToUsage?: typeof addVenueToUsage;
    addLicenseVenueToUsage?: typeof addLicenseVenueToUsage;
    saveResultData?: IRepertoireComponentDataItem;
    getUsagePoolsByDistribution?: (distributionID: number) => any
    componentViews?: IComponentViewReduxStore;
    updateComponentViews?: (views: IComponentView[]) => void;
    getComponentViews?: (componentName: string, componentInstance: string) => void;
    setActiveComponentView?: (componentView: IComponentView) => void;
    activeComponentView?: IComponentView;
    usageSearchResultsViewsActiveComponentView?: IComponentView;
    licenseVenuesSearchResults?: ILicenseCustomerVenue[];
    componentViewPreference?: IComponentViewsPreference;
    isCatchupAllocationsEnabled?: boolean;
    allocateDistributionConfirmationClose?: () => void;
    expandMatchProductResult?: (matchWorkResults: number) => void;
    expandedMatchProductResults?: number[];
    usageSearchResultConfiguration?: IUsageSearcResultConfiguration;
    getWorksFromPackage:(packageItems:any,dataSource:any)=> void;
    createWorksFromPackageJob: (model: IAgreementWorksFromPackageJobRequest) => Promise<IAgreementWorksFromPackageJobResponse>;
}

export interface IShowFieldSettingViewModalProps {
    componentViewData: IRepertoireComponentDataItem;
    componentInstance: string;
    dataGridViewData: IRepertoireComponentDataItem;
    onClickSave: () => void;
    inverted?: boolean;
    key?: string;
    usageType?: string;
}


export const RepertoireModal: React.SFC<IRepertoireModalProps> = ({ 
    hideModal,
    updateModalComment,
    modalContent,
    modalComponentInstance,
    displayModalCloseButton,
    modalProps,
    modalIndex,
    modalKey,
    searchViewData,
    searchResultsTableData,
    workNotFoundViewData,
    loadingViewData,
    dataGridTableData,
    dataSource,
    setDataSource,
    agreementsDataSource,
    productDataSource,
    modalTitle,
    searchArtists,
    searchVenues,
    searchLicenseVenues,
    searchContributors,
    searchWorks,
    searchSubjects,
    searchProducts,
    artistsSearchResults,
    venuesSearchResults,
    licenseVenuesSearchResult,
    contributorsSearchResults,
    worksSearchResults,
    productSearchResults,
    workSubjectSearchResults,
    addArtistToWork,
    addArtistToProduct,
    addArtistToUsage,
    addWorkToProduct,
    updateWorkContributorIP,
    updateProductContributorIP,
    updateAgreementIP,
    updateAgreementSourceIP,
    updateAgreementWork,
    updateAgreementCarveOutProduct,
    getProductDetails,
    updateMatchingWork,
    updateMatchingProduct,
    yesNoPromptViewData,
    searchSuccessful,
    updateRelatedWork,
    updateWorkSourceIP,
    updateProductSourceIP,
    editableFields,
    updateEditableFields,
    expandedWorkResults,
    expandedProductResults,
    expandAll,
    expandWorkResult,
    expandProductResult,
    expandAllResults,
    modalMessage,
    modalDetailMessage,
    updateWorkflowViewData,
    indexOfFirstResult,
    indexOfLastResult,
    resultsPerPage,
    currentPage,
    resetPagination,
    updatePagination,
    usageSearchViewData,
    searchUsages,
    usageGroupsSearchResult,
    usageSearchResultsTableData,
    searchMatchWorks,
    searchMatchProducts,
    matchWorkSearchResult,
    addMatchworkToUsage,
    addMatchProductToUsage,
    expandMatchWorkResult,
    usageExpandAllResults,
    expandedMatchWorkResults,
    usageExpandAll,
    getUsageDetails,
    matchProductsSearchResult,
    lookupValues,
    searchDataChanged,
    ipMaintenanceGeneralDataViewData,
    addNewAccount,
    addNewWork,
    lookupSources,
    usageSourceMajors,
    usageSourceMinors,
    usageDistributions,
    usagePools,
    updateSelectionCriteria,
    updateRepresentationSelector,
    distributions,
    isReadOnlyModal,
    addFileToUpload,
    isDropZone,
    setProgressUploadFileProccess,
    containerDetailsWindowComponentData,
    droppedFiles,
    setInDropZone,
    importDistributionPools,
    importPoolWeightSettings,
    importWeightSettingCodes,
    tabs,
    activeTab,
    updateForeignSocietyInfo,
    getMatchingWorkInfo,
    distributionTypes,
    ipTransferViewData,
    showModal,
    searchIPs,
    ipTransfer,
    addIpToAdjustmentDetail,
    addWorkOrProductToUsageSearchCriteria,
    usageMatchingDefaultsWorks,
    usageMatchingDefaultsProducts,
    isRepertoireSearch,
    searchLicenseUser,
    licenseUserSearchResults,
    updateLicenceUserValues,
    addWorkToLicenseRequest,
    addIPToUsageDetails,
    addWorkToClaimRequest,
    commentCategoryFlag,
    addNewProduct,
    updateSubjectCode,
    incrementTempID,
    updateScheduledJobField,
    customer,
    updateUsageField,
    updateTerritorySelector,
    addVenueToUsage,
    addLicenseVenueToUsage,
    saveResultData,
    getUsagePoolsByDistribution,
    componentViews,
    updateComponentViews,
    getComponentViews,
    licenseVenuesSearchResults,
    allocateDistributionConfirmationClose,
    getAllowFileSelectInSelectionCriteria,
    allowFileSelectInSelectionCriteria,
    activeComponentView,
    setActiveComponentView,
    componentViewPreference,
    isCatchupAllocationsEnabled,
    expandedMatchProductResults,
    expandMatchProductResult,
    usageSearchResultConfiguration,
    getWorksFromPackage,
    createWorksFromPackageJob
}) => {
    const [isFormDirty, setIsFormDirty] = React.useState(false);
    const [showDirtyModal, setShowDirtyModal] = React.useState(false);

    const handleModalClose = () => {
        if (isFormDirty) { 
            setShowDirtyModal(true);
        } else {
            hideModal();    
            setIsFormDirty(false);
        }
    }

        const handleSaveClick = () => {
                hideModal();
                setIsFormDirty(false);
        }

    React.useEffect(() => {
        const close = (e) => {
            if (e.key === 'Escape') {
                hideModal();
            }
        }
        window.addEventListener('keydown', close)
        return () => window.removeEventListener('keydown', close)
    }, [])

    const handlePreventClickPropagation = (event) => {
        if (event.type === 'click') {
            event.stopPropagation();
        }
    };

    const handleImportUsagePoolWeightMultiplier = (params: any, fileName: string) => {
        const pool: IUsagePoolState = params["pool"];
        const poolDimensionsAndDatesID: number = params["poolDimensionsAndDatesID"];
        importPoolWeightSettings(pool, poolDimensionsAndDatesID, fileName)
    }

    const handleImportWeightSettingCodes = (params: any, fileName: string) => {
        const pool: IUsagePoolState = params["pool"];
		const poolDimensionsAndDatesID: number = params["poolDimensionsAndDatesID"];
        importWeightSettingCodes(pool, poolDimensionsAndDatesID, fileName)
    }

    const [modalPropsUsers, setModalPropsUsers] = React.useState(modalProps);

    const smallModals = new Set([YES_NO_PROMPT_VIEW, SCHEDULED_JOB_MODAL_VIEW, COMMENTS_VIEW, UPDATE_WORKFLOW_VIEW, MESSAGE_VIEW, JOB_CREATED_VIEW]);
    const modalSizeClass = smallModals.has(modalContent) ? "modal--small" : "modal--large";
    const messageModalClass = modalContent === MESSAGE_VIEW ? "modal--message" : "";
	const isImportModal = (modalContent === IMPORT_DATA_VIEW || 
        modalContent === IMPORT_POOL_DATA_VIEW_DISTRIBUTIONS || 
        modalContent === IMPORT_WEIGHTS_DATA_VIEW_POOL || 
        modalContent === IMPORT_WEIGHTS_CODES_DATA_VIEW_POOL)
    const importClass = isImportModal ? "importModal" : "";

    const noFixedPartModals = new Set([YES_NO_PROMPT_VIEW, SCHEDULED_JOB_MODAL_VIEW, MESSAGE_VIEW, JOB_CREATED_VIEW]);

    const renderModalContent = () => {
        switch (modalContent) {
            case SELECTION_CRITERIA_VIEW:
                return <>
                        <SelectionCriteriaView
                            hideModal={hideModal}
                            isCatchupAllocationsEnabled={isCatchupAllocationsEnabled}
                            distributionPool={modalProps}
                            updateSelectionCriteria={updateSelectionCriteria}
                            dataGridTableData={dataGridTableData}
                            lookupValues={lookupValues}
                            distributions={distributions}
                            isReadOnly={isReadOnlyModal}
                            tabs={tabs}
                            activeTab={activeTab}
                            incrementTempID={incrementTempID}
                            getAllowFileSelectInSelectionCriteria={getAllowFileSelectInSelectionCriteria}
                            allowFileSelect={allowFileSelectInSelectionCriteria}
                            customer={customer}
                            getUsagePoolsByDistribution={getUsagePoolsByDistribution}
                        />
                </>;
            case COMMENTS_VIEW: {
                const updateComment = (commentId: number, value: any, fieldName: string) => {
                    let newModalProps = Object.assign({}, modalProps);
                    newModalProps[fieldName].value = value;
                    updateModalComment(newModalProps);
                }

                return <CommentsView
                    commentItem={modalProps}
                    updateComment={updateComment}
                    lookupValues={lookupValues}
                    commentCategoryFlag={commentCategoryFlag}
                />;
            }

            case USAGE_MAINTENANCE_COMMENTS_MODAL: {
                return (
                    <UsageMaintenanceGridCommentsModalView
                        hideModal={hideModal}
                        modalProps ={modalProps}
                        updateUsageField={updateUsageField}
                        index={modalIndex}
                        title={modalTitle}
                    />
                )
            }
            case SEARCH_VIEW: {
                const updateContributorIP = (workContributor: IContributorItem, ip: IP) => {
                    updateWorkContributorIP(dataSource as DataSource, workContributor, ip, customer)
                };
                const newDataSource = (modalProps && modalProps["dataSource"]) ? DataSource.Repertoire : dataSource;
                return (
                    <SearchView
                        searchViewData={searchViewData}
                        componentInstance={modalComponentInstance}
                        modalProps={modalProps}
                        modalIndex={modalIndex}
                        modalKey={modalKey}
                        dataSource={newDataSource}
                        agreementsDataSource={agreementsDataSource}
                        searchResultsTableData={searchResultsTableData}
                        searchArtists={searchArtists}
                        searchVenues={searchVenues}
                        searchLicenseVenues={searchLicenseVenues}
                        addVenueToUsage={addVenueToUsage}
                        addLicenseVenueToUsage={addLicenseVenueToUsage}
                        searchContributors={searchContributors}
                        searchWorks={searchWorks}
                        searchSubjects={searchSubjects}
                        updateSubjects={updateSubjectCode}
                        searchProducts={searchProducts}
                        artistsSearchResults={artistsSearchResults}
                        venuesSearchResults={venuesSearchResults}
                        licensesSearchResults={ licenseVenuesSearchResults }
                        contributorsSearchResults={contributorsSearchResults}
                        worksSearchResults={worksSearchResults}
                        productSearchResults={productSearchResults}
                        subjectSearchResults={workSubjectSearchResults}
                        addArtistToWork={addArtistToWork}
                        addArtistToProduct={addArtistToProduct}
                        addArtistToUsage={addArtistToUsage}
                        addWorkToProduct={addWorkToProduct}
                        updateWorkContributorIP={updateContributorIP}
                        updateProductContributorIP={updateProductContributorIP}
                        updateAgreementIP={updateAgreementIP}
                        updateAgreementSourceIP={updateAgreementSourceIP}
                        updateAgreementWork={updateAgreementWork}
                        updateAgreementCarveOutProduct={updateAgreementCarveOutProduct}
                        getProductDetails={getProductDetails}
                        updateMatchingWork={updateMatchingWork}
                        updateMatchingProduct={updateMatchingProduct}
                        hideModal={hideModal}
                        searchSuccessful={searchSuccessful}
                        updateRelatedWork={updateRelatedWork}
                        updateWorkSourceIP={updateWorkSourceIP}
                        updateProductSourceIP={updateProductSourceIP}
                        expandedWorkResults={expandedWorkResults}
                        expandedProductResults={expandedProductResults}
                        expandAll={expandAll}
                        expandWorkResult={expandWorkResult}
                        expandProductResult={expandProductResult}
                        expandAllResults={expandAllResults}
                        indexOfFirstResult={indexOfFirstResult}
                        indexOfLastResult={indexOfLastResult}
                        resultsPerPage={resultsPerPage}
                        currentPage={currentPage}
                        resetPagination={resetPagination}
                        updatePagination={updatePagination}
                        searchIPs={searchIPs}
                        addIpToAdjustmentDetail={addIpToAdjustmentDetail}
                        searchLicenseUser={searchLicenseUser}
                        licenseUserSearchResults={licenseUserSearchResults}
                        updateLicenceUserValues={updateLicenceUserValues}
                        addWorkToLicenseRequest={addWorkToLicenseRequest}
                        addIPToUsageDetails={addIPToUsageDetails}
                        addWorkToClaimRequest={addWorkToClaimRequest}
                        lookupValues={lookupValues}
                        licenseVenuesSearchResults={licenseVenuesSearchResults}
                        addMatchProductToUsage={addMatchProductToUsage}
                        usageMatchingDefaultsProducts={usageMatchingDefaultsProducts}
                        usageGroup={tabs[activeTab]?.usageMaintenanceState?.usageGroup}
                        expandedMatchProductResults={expandedMatchProductResults}
                        expandMatchProductResult={expandMatchProductResult}
                        usageExpandAllResults={usageExpandAllResults}
                    />
                );
            }
            case WORK_NOT_FOUND_VIEW: {
                return <WorkNotFoundView fields={workNotFoundViewData.fields} workId={modalProps} />
            }
            case LOADING_VIEW: {
                return <LoadingView fields={loadingViewData.fields} />
            }
            case MESSAGE_VIEW: {
                return <PopUpInfo textToScreen={modalProps.textToScreen} />
            }
            case SPLIT_LICENSE_VIEW: {
                return <SplitLicenseView {...modalProps} />
            }
            case YES_NO_PROMPT_VIEW: {
                return <YesNoPromptView fields={yesNoPromptViewData.fields} props={modalProps} />
            }
            case SCHEDULED_JOB_MODAL_VIEW: {
                let filteredFields = modalProps.fields.filter(f => f.componentInstance === modalComponentInstance);

                return <ScheduledJobModalView
                    fields={filteredFields}
                    noCallback={modalProps.noCallback}
                    yesCallback={modalProps.yesCallback}
                    upsertScheduledJob={modalProps.upsertScheduledJob} 
                    componentName={modalComponentInstance} 
                    tab={tabs[activeTab]} 
                    changeData={updateScheduledJobField} 
                />
            }
            case DISTRIBUTION_VERSION_HISTORY_VIEW:
            case VERSION_HISTORY_VIEW: {
                const filteredFields = {
                    ...searchResultsTableData,
                    fields:
                        modalComponentInstance === SEARCH_VIEW_WORKS
                            ? searchResultsTableData.fields.filter(x => x.name !== 'intrayProductID')
                            : modalComponentInstance === SEARCH_VIEW_PRODUCTS
                                ? searchResultsTableData.fields.filter(x => x.name !== 'intrayWorkID')
                                : searchResultsTableData.fields.filter(x => x.name !== 'intrayWorkID' && x.name !== 'intrayProductID')
                };

                return <VersionHistoryView
                    searchResultsTableData={filteredFields}
                    hideModal={hideModal}
                    props={modalProps}
                    updatePagination={updatePagination}
                    componentInstance={modalContent}
                />
            }
            case WORK_SUBMISSION_VIEW: {
                return (
                    <SubmissionPromptView
                        props={modalProps} />
                )
            }
            case FIELD_SETTING_VIEW: {
                var key = "default";
                if (modalProps["key"]) {
                    key = modalProps["key"]
                }

                if (key === USAGE_ROWS_SECTION_KEY) {
                    return <UsageMaintenanceDetailTableFieldSettingView
                                componentViewPreference={componentViewPreference}
                                getComponentViews={getComponentViews}
                                activeComponentView={componentViews?.usageMaintenanceGridViewsDetails?.activeComponentView ? componentViews.usageMaintenanceGridViewsDetails.activeComponentView : undefined}
                                setActiveComponentView={setActiveComponentView}
                                updateComponentViews={updateComponentViews}
                                componentViews={componentViews?.usageMaintenanceGridViewsDetails?.componentViews ? componentViews.usageMaintenanceGridViewsDetails.componentViews : []}
                                componentInstance={modalProps["componentInstance"]}
                                componentViewData={modalProps["componentViewData"]}
                                dataGridViewData={modalProps["dataGridViewData"]}
                                onClickSave={handleSaveClick}
                                tableContents={editableFields['default']}
                                updateEditableFields={updateEditableFields}
                                onClickCancel={handleModalClose}
                                editableFieldsKey={key}
                                setIsFormDirty={setIsFormDirty}
                    />
                }
                if (key === 'usageResultsTable') {
                    return <UsageResultsFieldSettingView
                                componentViewPreference={componentViewPreference}
                                getComponentViews={getComponentViews}
                                activeComponentView={componentViews?.usageSearchResultsViews?.activeComponentView ? componentViews.usageSearchResultsViews.activeComponentView : undefined}
                                setActiveComponentView={setActiveComponentView}
                                updateComponentViews={updateComponentViews}
                                componentViews={componentViews?.usageSearchResultsViews?.componentViews ? componentViews.usageSearchResultsViews.componentViews : []}
                                componentInstance={modalProps["componentInstance"]}
                                componentViewData={modalProps["componentViewData"]}
                                dataGridViewData={modalProps["dataGridViewData"]}
                                onClickSave={handleSaveClick}
                                tableContents={editableFields[key]}
                                updateEditableFields={updateEditableFields}
                                onClickCancel={handleModalClose}
                                editableFieldsKey={key}
                                setIsFormDirty={setIsFormDirty}
                            />
                }
                
                if (key === USAGE_PAGE_VIEW) {
                    return <UsageMaintenanceFieldSettingView
                        componentViewPreference={componentViewPreference}
                        getComponentViews={getComponentViews}
                        activeComponentView={componentViews?.usageMaintenanceGeneralDataViews?.activeComponentView ? componentViews?.usageMaintenanceGeneralDataViews.activeComponentView : undefined}
                        setActiveComponentView={setActiveComponentView}
                        updateComponentViews={updateComponentViews}
                        componentViews={componentViews?.usageMaintenanceGeneralDataViews.componentViews ? componentViews.usageMaintenanceGeneralDataViews.componentViews : []}
                        componentInstance={modalProps["componentInstance"]}
                        componentViewData={modalProps["componentViewData"]}
                        dataGridViewData={modalProps["dataGridViewData"]}
                        usageType={modalProps["usageType"]}
                        onClickSave={modalProps["onClickSave"]}
                        tableContents={editableFields['default']}
                        updateEditableFields={updateEditableFields}
                        onClickCancel={handleModalClose}
                        editableFieldsKey={key}
                        setIsFormDirty={setIsFormDirty}
                    />
                }
               
                return <FieldSettingView
                    componentInstance={modalProps["componentInstance"]}
                    componentViewData={modalProps["componentViewData"]}
                    dataGridViewData={modalProps["dataGridViewData"]}
                    onClickSave={modalProps["onClickSave"]}
                    tableContents={editableFields[key]}
                    updateEditableFields={updateEditableFields}
                    onClickCancel={hideModal}
                    editableFieldsKey={key}
                />
            }
            case ASSING_WORKFLOW_VIEW: {
                const updateUsers = (username: string, value: any, fieldName: string) => {
                    setModalPropsUsers(prevProps => ({
                        items: prevProps.items.map(item =>
                            item.userName.value === username
                                ? {...item, [fieldName]: { value }} : item
                        )
                    }));
                };
                return <AssingWorkflowTo
                    hideModal={hideModal}
                    assingTo={modalProps["assingTo"]}
                    assingWorkflowViewData={modalProps["assingWorkflowViewData"]}
                    items={modalProps["items"]}
                    searchResultsTableData={modalProps["searchResultsTableData"]}
                    updatePagination={updatePagination}
                    totalWorkflows={modalProps["totalWorkflows"]}
                    updateUsers={updateUsers}
                />
            }
            case UPDATE_WORKFLOW_VIEW: {
                return <UpdateWorkflowView
                    hideModal={hideModal}
                    updateWorkflowViewData={updateWorkflowViewData}
                    updateWorkflows={modalProps["updateWorkflows"]} />
            }
            case USAGESEARCH_VIEW: {
                const usageSourceMatchType = modalProps?.usageType === USAGETOPRODUCT
                    ? USAGE_TO_PRODUCT
                    : modalProps?.usageType === USAGETOWORK
                        ? USAGE_TO_WORK
                        : undefined;
                const filteredLookupSources = usageSourceMatchType && lookupSources
                    ? lookupSources.filter(source => source.matchType === usageSourceMatchType)
                    : lookupSources;

                return (
                    <UsageSearchView
                        searchViewData={usageSearchViewData}
                        searchResultsTableData={usageSearchResultsTableData}
                        componentInstance={modalComponentInstance}
                        modalProps={modalProps}
                        searchUsages={searchUsages}
                        usageGroupsSearchResult={usageGroupsSearchResult}
                        searchSuccessful={searchSuccessful}
                        indexOfFirstResult={indexOfFirstResult}
                        indexOfLastResult={indexOfLastResult}
                        resultsPerPage={resultsPerPage}
                        currentPage={currentPage}
                        resetPagination={resetPagination}
                        updatePagination={updatePagination}
                        hideModal={hideModal}
                        searchMatchWorks={searchMatchWorks}
                        searchMatchProducts={searchMatchProducts}
                        matchWorkSearchResult={matchWorkSearchResult}
                        getUsageDetails={getUsageDetails}
                        expandMatchWorkResult={expandMatchWorkResult}
                        usageExpandAll={usageExpandAll}
                        usageExpandAllResults={usageExpandAllResults}
                        expandedMatchWorkResults={expandedMatchWorkResults}
                        addMatchworkToUsage={addMatchworkToUsage}
                        addMatchProductToUsage={addMatchProductToUsage}
                        searchDataChanged={searchDataChanged}
                        usageType={modalProps?.usageType}
                        initialSearchValues={modalProps?.initialSearchValues}
                        onUsageGroupSelected={modalProps?.onUsageGroupSelected}
                        singleUsageGroupSelection={modalProps?.singleUsageGroupSelection}
                        disableUsageOpen={true}
                        usageSearchResultConfiguration={usageSearchResultConfiguration}
                        matchProductsSearchResult={matchProductsSearchResult}
                        lookupValues={lookupValues}
                        lookupSources={filteredLookupSources}
                        sourceMajors={usageSourceMajors}
                        sourceMinors={usageSourceMinors}
                        distributions={usageDistributions}
                        pools={usagePools}
                        distributionTypes={distributionTypes}
                        usageGroup={tabs[activeTab]?.usageMaintenanceState?.usageGroup}
                        addWorkOrProductToUsageSearchCriteria={addWorkOrProductToUsageSearchCriteria}
                        usageMatchingDefaultsWorks={usageMatchingDefaultsWorks}
                        usageMatchingDefaultsProducts={usageMatchingDefaultsProducts}
                    />
                );
            }
            case FOREIGN_SOCIETY_INFO_VIEW:
                const updateForeignSocietyInfoField = (distributionPoolID: number, value: any, fieldName: string) => {
                    updateForeignSocietyInfo(distributionPoolID, value, fieldName);
                    modalProps[fieldName].value = value;
                    updateModalComment(modalProps);
                }

                const handleFileUploaded = (file: IAttachedFile) => {
                    if (tabs && tabs[activeTab] && tabs[activeTab].distributionMaintenanceState && tabs[activeTab].distributionMaintenanceState.distribution) {
                        const distribution = tabs[activeTab].distributionMaintenanceState.distribution;
                        const pool = distribution.distributionPools?.find(p => p.distributionPoolID === modalProps.distributionPoolID);
                        if (pool) {
                            if (!pool.attachedFiles) {
                                pool.attachedFiles = [];
                            }
                            pool.attachedFiles.push(file);
                            updateModalComment({ ...modalProps });
                        }
                    }
                };

                const handleFileRemoved = (file: IAttachedFile) => {
                    if (tabs && tabs[activeTab] && tabs[activeTab].distributionMaintenanceState && tabs[activeTab].distributionMaintenanceState.distribution) {
                        const distribution = tabs[activeTab].distributionMaintenanceState.distribution;
                        const pool = distribution.distributionPools?.find(p => p.distributionPoolID === modalProps.distributionPoolID);
                        if (pool && pool.attachedFiles) {
                            pool.attachedFiles = pool.attachedFiles.filter(f => 
                                f.attachedFileID !== file.attachedFileID && 
                                f.guid !== file.guid
                            );
                            updateModalComment({ ...modalProps });
                        }
                    }
                };

                const distributionPoolAttachedFiles = tabs && tabs[activeTab] && tabs[activeTab].distributionMaintenanceState && tabs[activeTab].distributionMaintenanceState.distribution
                    ? tabs[activeTab].distributionMaintenanceState.distribution.distributionPools
                        .find(pool => pool.distributionPoolID === modalProps.distributionPoolID)
                        ?.attachedFiles || []
                    : [];

                const distributionId = tabs && tabs[activeTab] && tabs[activeTab].distributionMaintenanceState && tabs[activeTab].distributionMaintenanceState.distribution
                    ? tabs[activeTab].distributionMaintenanceState.distribution.distributionID
                    : null;

                return (
                    <ForeignSocietyInfoView
                        hideModal={hideModal}
                        distributionPool={modalProps}
                        lookupValues={lookupValues}
                        dataGridTableData={dataGridTableData}
                        updateForeignSocietyInfo={updateForeignSocietyInfoField}
                        isReadOnly={isReadOnlyModal}
                        attachedFiles={distributionPoolAttachedFiles}
                        onFileUploaded={handleFileUploaded}
                        onFileRemoved={handleFileRemoved}
                    />
                );
            case MATCHING_WORK_MORE_INFO_VIEW:
                if (!tabs[activeTab].matchingWork || tabs[activeTab].matchingWork.workID !== modalProps) {
                    getMatchingWorkInfo(modalProps);
                }

                return (
                    <UsageSearchView
                        searchViewData={usageSearchViewData}
                        searchResultsTableData={usageSearchResultsTableData}
                        componentInstance={SEARCH_VIEW_USAGES}
                        modalProps={modalProps}
                        searchUsages={searchUsages}
                        usageGroupsSearchResult={usageGroupsSearchResult}
                        searchSuccessful={searchSuccessful}
                        indexOfFirstResult={indexOfFirstResult}
                        indexOfLastResult={indexOfLastResult}
                        resultsPerPage={resultsPerPage}
                        currentPage={currentPage}
                        resetPagination={resetPagination}
                        updatePagination={updatePagination}
                        hideModal={hideModal}
                        searchMatchWorks={searchMatchWorks}
                        searchMatchProducts={searchMatchProducts}
                        matchWorkSearchResult={matchWorkSearchResult}
                        getUsageDetails={getUsageDetails}
                        expandMatchWorkResult={expandMatchWorkResult}
                        usageExpandAll={usageExpandAll}
                        usageExpandAllResults={usageExpandAllResults}
                        expandedMatchWorkResults={expandedMatchWorkResults}
                        addMatchworkToUsage={addMatchworkToUsage}
                        addMatchProductToUsage={addMatchProductToUsage}
                        searchDataChanged={searchDataChanged}
                        matchProductsSearchResult={matchProductsSearchResult}
                        lookupValues={lookupValues}
                        lookupSources={lookupSources}
                        distributionTypes={distributionTypes}
                        onlySearchResults={true}
                        isDistributed={tabs[activeTab].matchingWork ? tabs[activeTab].matchingWork.isDistributed : undefined}
                        dateOfRegistration={tabs[activeTab].matchingWork ? tabs[activeTab].matchingWork.dateOfRegistration : undefined}
                        tabs={tabs}
                        activeTab={activeTab}
                    />
                );
            case IP_TRANSFER_VIEW:

                return (
                    <IpTransferView
                        hideModal={hideModal}
                        showModal={showModal}
                        props={modalProps}
                        ipTransferViewData={ipTransferViewData}
                        searchIPs={searchIPs}
                        sourceIp={tabs[activeTab].interestedPartyMaintenanceState.interestedParty ? tabs[activeTab].interestedPartyMaintenanceState.interestedParty.ipBaseNumber : undefined}
                        ipTransfer={ipTransfer}
                        tabs={tabs}
                        activeTab={activeTab}
                    />
                );
            case JOB_CREATED_VIEW:
                return (<JobCreatedView textToScreen={modalProps.textToScreen} hideModal={hideModal} allocateDistributionConfirmationClose={allocateDistributionConfirmationClose} />
                );
            case ADD_WORKS_FROM_PACKAGE_VIEW:
                return (
                    <AddWorksFromPackageView
                        hideModal={hideModal}
                        packageDetails={modalProps.packageDetails}
                        dataSource={modalProps.dataSource}
                        agreementId={modalProps.agreementId}
                        getWorksFromPackage={getWorksFromPackage}
                        createWorksFromPackageJob={createWorksFromPackageJob}
                        agreementWorksFromPackageJobThreshold={modalProps.agreementWorksFromPackageJobThreshold}
                    />
                )
            default:
                return null;
        }
    };

    const renderDataSelector = () => {
        if (modalComponentInstance === PRODUCT_WORKS_KEY && productDataSource === INTRAY || modalComponentInstance === COMPONENTS_KEY) {
            return (
                <SelectorView
                    selection={dataSource}
                    setSelection={setDataSource}
                    option1={INTRAY}
                    option1Label={"Intray"}
                    option2={REPERTOIRE}
                    option2Label={"Repertoire"}
                    selectorTitle={DATA_SOURCE}
                />
            );
        }
    }

    const handleAddNewWork = () => {
        hideModal();
        addNewWork(lookupValues, getDataAction(DataSource.Intray, WORK_MAINTENANCE_TOOLBAR), true)
    }

    const handleAddNewProduct = () => {
        hideModal();
        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
            .then(formats => {
                addNewProduct(lookupValues, true, null, formats)
            })
    }

    const handleAssignTo = () => {
        const assignTo = modalProps["assingTo"];
        const assignedUsers = modalPropsUsers.items.filter(user => user.assigned && user.assigned.value);
        
        const transformedUsers = assignedUsers.map(user => ({
            userName: user.userName.value,
            numberOfWorkflows: parseInt(user.numberOfWorkflows.value) || -1,
            assigned: user.assigned.value
        }));

        if (transformedUsers.length > 0) {
            assignTo(transformedUsers);
        } else {
            hideModal();
        }
    };


    const renderModal = () => {
        const styleModalContent = (modalContent === ASSING_WORKFLOW_VIEW || modalContent === UPDATE_WORKFLOW_VIEW || modalContent === SCHEDULED_JOB_MODAL_VIEW) ? "modalBody noFlex" : "modalBody";
        if (modalContent === WORK_SUBMISSION_VIEW) {
            return (
                <div className="repertoireModal">
                    {renderModalContent()}
                </div>
            );
        }
        if (modalContent === LOADING_VIEW) {
            return (
                <div className="loaderWrapper">
                    <div className="spinner-dualball">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            );
        }
        if (modalContent === SHORTCUT_KEY_MODAL) {
            return <div className="repertoireModal">
                <ShortcutKeyModalView hideModal={hideModal} />
            </div>
        }
        if (modalContent === EDIT_JOB_SCHEDULE_MODAL) {
            return <div className="repertoireModal">
                <EditScheduledJobsModalView  hideModal={hideModal} scheduledJob={modalProps}  />
            </div>
        }
        if (modalContent === JOBS_IN_PROGRESS_MODAL) {
            return <div className="repertoireModal">
                <JobsInProgressModal hideModal={hideModal} jobsToDisplay={REPERTOIRE_PAGE_JOBS} />
            </div>
        }
        if (modalContent === TERRITORY_SELECTION_VIEW && modalComponentInstance === CONTRIBUTORS_KEY) {
            return <div className="repertoireModal">
                <TerritorySelectionView
                    hideModal={hideModal}
                    workContributor={modalProps}
                    updateRepresentationSelector={updateRepresentationSelector}
                    updateTerritorySelector={updateTerritorySelector}
                    dataGridTableData={dataGridTableData}
                    lookupValues={lookupValues}
                    isReadOnly={isReadOnlyModal}
                    incrementTempID={incrementTempID}
                    title={modalTitle}
                    modalIndex={modalIndex}                    
                />
            </div>
        }
        if (modalContent === TERRITORY_SELECTION_VIEW) {
            return <div className="repertoireModal">
                <TerritorySelectionView
                    hideModal={hideModal}
                    interestedPartyRepresentation={modalProps}
                    updateRepresentationSelector={updateRepresentationSelector}
                    dataGridTableData={dataGridTableData}
                    lookupValues={lookupValues}
                    isReadOnly={isReadOnlyModal}
                    incrementTempID={incrementTempID}
                    title={modalTitle}
                    modalIndex={modalIndex}
                />
            </div>
        }
        if (modalContent === AGREEMENTS_APPLICABLE_WORKS_SEARCH) {
            return <AgreementApplicableWorkSearchView
            searchViewData={searchViewData}
            searchSuccessful={searchSuccessful}
            searchResultsTableData={searchResultsTableData}
            indexOfFirstResult={indexOfFirstResult}
            indexOfLastResult={indexOfLastResult}
            resultsPerPage={resultsPerPage}
            currentPage={currentPage}
            resetPagination={resetPagination}
            updatePagination={updatePagination}
            hideModal={hideModal}
            modalTitle={modalTitle}
            handleAddNewWork={handleAddNewWork}
            searchWorks={searchWorks}
            updateAgreementWork={updateAgreementWork}
            worksSearchResults={worksSearchResults}
            modalProps={modalProps}
            expandedWorkResults={expandedWorkResults}
            expandAll={expandAll}
            expandWorkResult={expandWorkResult}
            expandAllResults={expandAllResults}
            />
        }
        if (modalContent === POOL_SELECTION_VIEW) {
            return <div className="repertoireModal">
                <PoolSelectionView
                    hideModal={hideModal}
                    interestedPartyRepresentation={modalProps}
                    updateRepresentationSelector={updateRepresentationSelector}
                    dataGridTableData={dataGridTableData}
                    lookupValues={lookupValues}
                    isReadOnly={isReadOnlyModal}
                    incrementTempID={incrementTempID}
                    title={modalTitle}
                    modalIndex={modalIndex}
                    pools={tabs[activeTab].usagePoolSearchResult}
                />
            </div>
        }
        if (modalContent === REJECT_UP_WORKFLOW) {
            return <RejectWorkflowView props={modalProps} hideModal={hideModal} lookupValues={lookupValues} />
        }
        if (modalContent === WORK_SEARCH_VIEW) {
            return <ProductWorkSearchModalViewContainer
                searchWorks={searchWorks}
                isDataSourceIntray={modalProps["isDataSourceIntray"]}
                searchViewData={searchViewData}
                worksSearchResults={worksSearchResults}
                searchSuccessful={searchSuccessful}
                searchResultsTableData={searchResultsTableData}
                lookupValues={lookupValues}
                hideModal={hideModal}
                modalTitle={modalTitle}
                handleAddNewWork={handleAddNewWork}
                addWorkToProduct={addWorkToProduct}
                saveResultData={saveResultData}
            />
        }
        if (modalContent === USAGESEARCH_VIEW && modalComponentInstance === SEARCH_VIEW_USAGES_USAGE_TO_WORK) {
            return <UsageWorkSearchModalContainer
                searchWorks={searchWorks}
                searchViewData={searchViewData}
                worksSearchResults={worksSearchResults}
                searchSuccessful={searchSuccessful}
                searchResultsTableData={searchResultsTableData}
                lookupValues={lookupValues}
                hideModal={hideModal}
                modalTitle={modalTitle}
                handleAddNewWork={handleAddNewWork}
                setTitle={modalProps['setTitle']}
            />
        }

        if (modalContent === USAGESEARCH_VIEW && modalComponentInstance === SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT) {
            return <UsageProductSearchModalViewContainer
                searchMatchProducts={searchMatchProducts}
                searchViewData={searchViewData}
                searchSuccessful={searchSuccessful}
                searchResultsTableData={searchResultsTableData}
                lookupValues={lookupValues}
                hideModal={hideModal}
                modalTitle={modalTitle}
                handleAddNewWork={handleAddNewProduct}
                setTitle={modalProps['setTitle']}
            />
        }

        if (isImportModal) {
            const importDataProps: IImportViewProps = {
                    containerDetailsWindowComponentData: containerDetailsWindowComponentData,
                    pageContentIsActive: true,
                    fileMetadataChanged: fileMetadataChanged,
                    openDirectory: undefined,
                    currentDirectory: "",
                    toggleSidebarCollapsed: undefined,
                    addFileToUpload: addFileToUpload,
                    editingChanged: undefined,
                    droppedFiles: droppedFiles,
                    validationMessageChanged: undefined,
                    saveState: undefined,
                    setInDropZone: setInDropZone,
                    sortColumn: sortColumn,
                    isDropZone: isDropZone,
                    setProgressUploadFileProccess: setProgressUploadFileProccess,
                    isRepertoireModule: false,
                    lookupValues: lookupValues,
                    importData: undefined,
                    tabs: tabs,
                    activeTab: activeTab,
                    hideModal: hideModal,
                    importProps: modalProps
            }

            switch (modalContent) {
                case IMPORT_DATA_VIEW:
                case IMPORT_POOL_DATA_VIEW_DISTRIBUTIONS:
                    importDataProps.importData = importDistributionPools;
                    importDataProps.currentDirectory = "distributions";
                    break;
                case IMPORT_WEIGHTS_DATA_VIEW_POOL:
                    importDataProps.importData = handleImportUsagePoolWeightMultiplier.bind(this);
                    importDataProps.currentDirectory = "pools";
                    break;
                case IMPORT_WEIGHTS_CODES_DATA_VIEW_POOL:
                    importDataProps.importData = handleImportWeightSettingCodes.bind(this);
                    importDataProps.currentDirectory = "pools";
                    break;
            }
            return (
                <div className="repertoireModal">
                    <div className="modal-dialog modalLarge settingsModal">
                        <div className="modal-content">
                            <div className='modal-header'>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={hideModal}>
                                    <Dismiss20Regular title="Close" />
                                </button>
                                <h1 className="modal-title">{modalTitle}</h1>
                            </div>
                            <div className="modal-body paddingVerticalVeryLarge" >

                                {modalContent === IMPORT_POOL_DATA_VIEW_DISTRIBUTIONS && <div>
                                    {"Import pools directly to the Distributions via a CSV format file containing four columns for the below data values:"}
                                    <div className="poolsImportTextBox flexColumn">
                                        <div>
                                            <label>{"• Pool code:"}</label>{" Pool Code for the pool to be imported to the Distribution (mandatory)"}
                                        </div>
                                        <div>
                                            <label>{"• Segment:"}</label>{" A sub-label for a pool, differentiating between potential differing data and/or amounts being allocated to the same Pool Code (Conditional on duplicate Pool Code entry)."}
                                        </div>
                                        <div>
                                            <label>{"• Amount to Allocate:"}</label>{" The total amount assigned for Allocation for this Pool"}
                                        </div>
                                        <div>
                                            <label>{"• Value per point:"}</label>{" The amount per point that must be allocated."}
                                        </div>
                                    </div>
                                    {"This file can be used in conjunction with manual pool additions. Pool and segment combinations will be added where they didn't exist before. If duplicates but with different 'amount to allocate' and 'nominal point value' amounts, the existing amounts will be updated."}
                                </div>}
                                {modalContent === IMPORT_WEIGHTS_DATA_VIEW_POOL && <div>
                                    {"Import pool weight settings directly to the Pool via a CSV format file containing the columns for the below data values:"}
                                    <div className="poolsImportTextBox flexColumn">
                                        <div>
                                            <label>{"• Weighting Code: "}</label>{' Weighting Code e.g. Background, Featured, Theme (mandatory).'}
                                        </div>
                                        <div>
                                            <label>{"• Music Source: "}</label>{' Optional Music Source'}
                                        </div>
                                        <div>
                                            <label>{"• Use: "}</label>{'Optional Use e.g. B for Background'}
                                        </div>
                                        <div>
                                            <label>{"• From and To Times (HH:MM:SS): "}</label>{' Applicable Usage Time of Day from and to range.'}
                                        </div>
                                        <div>
                                            <label>{"• Dim1 to Dim5: "}</label>{' Applicable Dimension fields 1 to 5.'}
                                        </div>
                                        <div>
                                            <label>{"• Weight Multiplier: "}</label>{' Applicable Weight Multiplier - decimal 38/18 (mandatory).'}
                                        </div>
                                    </div>
                                    {"You can not have the same combination of dimension values (including Music Source, Use and Time Ranges) configured more than once effective at the same time. Existing weight multipliers for the selected time period will be replaced."}
                                </div>}
                                {modalContent === IMPORT_WEIGHTS_CODES_DATA_VIEW_POOL && <div>
                                    {"Import Pool Weight Setting Codes via a CSV format file containing the columns for the data values below:"}
                                    <div className="poolsImportTextBox flexColumn">
                                        <div>
                                            <label>{"• Weight Setting Code: "}</label>{' One of the values for the weight setting code. E.G. TV1, TV2, etc... - text (mandatory).'}
                                        </div>
                                        <div>
                                            <label>{"• Multiplier: "}</label>{' Multiplier to use in Weight Settings for this Weight Setting Code - decimal 28/18 (mandatory).'}
                                        </div>
                                    </div>
                                    {"You can not have the same Weight Setting Code value more than once for the specified Effective Date Range. Existing Weight Setting Codes for the selected time period will be replaced."}
                                </div>}
                                
                                <ImportView {...importDataProps}/>
                            </div>
                            <div className=" flexRow flexJustifyContentRight marginVerticalVeryLarge borderTopGreyLine">
                                <div className="form-group col-sm-12 margin-topSmall marginHorizontalMedium alignRight" style={{ width: '300px' }}>
                                    <button className="button buttonAutowidth btn-defaultSecondary margin-rightMedium" onClick={hideModal}>{"Close"}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>);
        }

        return (
            modalContent === USAGE_MAINTENANCE_COMMENTS_MODAL ? (
                <div className="repertoireModal" onClick={handlePreventClickPropagation}>
                        <UsageMaintenanceGridCommentsModalView
                            hideModal={hideModal}
                            modalProps ={modalProps}
                            updateUsageField={updateUsageField}
                            index={modalIndex}
                            title={modalTitle}
                        />
                        </div>) : (
            <div className="repertoireModal" onClick={handlePreventClickPropagation}>
                <div className={`modal ${importClass} ${modalSizeClass} ${messageModalClass}`}>
                    <div className='modal-header'>
                        {displayModalCloseButton && (
                        <button type="button" data-testid="close-button" className="close" data-dismiss="modal" aria-hidden="true" onClick={handleModalClose}>
                            <Dismiss20Regular title="Close" />
                        </button>
                        )}
                        <h1 className="modal-title">{modalTitle}</h1>
                    </div>
                    <div className="fixedPart" />
                    <div className="dynamicPart">
                        {modalComponentInstance === CONTRIBUTORS_SEARCH_VIEW ?
                            <div className="newWorkButton" title="Create New Account">
                                
                            </div> : <></>}
                        {modalComponentInstance === PRODUCT_WORKS_KEY ?
                            <div className="newWorkButton" title="Create New Work" style={{ paddingRight: "24px" }}>
                                <div className="IconTextButton" onClick={handleAddNewWork}>
                                    <AddCircle20Regular
                                        className="icon"
                                        aria-hidden="true"
                                    />
                                    New Work
                                </div>
                            </div> : <></>}
                        {modalMessage && (<div className="modalBody modal-message">{modalMessage}</div>)}
                        {modalDetailMessage && (<div className="modalBody modal-detail">{modalDetailMessage}</div>)}
                        {modalContent === YES_NO_PROMPT_VIEW && <div className="button-separator"></div>}
                        {showDirtyModal && (
                            <div className="overlayAlert">
                                <div className="alertContent">
                                    <p>You have unsaved changes. Are you sure you want to leave?</p>
                                    <div className="buttonRow flexRow flexJustifyContentSpaceBetween">
                                    <ActionButton buttonText={modalProps["yesButtonText"] || "Yes"} buttonAction={() => {hideModal()}} />
                                    <ActionButton buttonText={modalProps["noButtonText"] || "No"} buttonAction={() => {
                                    setIsFormDirty(false);
                                    setShowDirtyModal(false);}
                                    } />
                                </div>
                                </div>
                            </div>
                        )}
                                <div className={styleModalContent}>
                                    {renderDataSelector() && <div className="flexRow">{renderDataSelector()}</div>}
                                    {renderModalContent()}
                                </div>
                    </div> 
                    {(modalComponentInstance === APPLICABLE_WORKS_KEY && searchSuccessful) ? (
                        <div key='action' className="doneButtonRow"> 
                            <div className="doneButton">
                                <ActionButton buttonText="Done" buttonAction={hideModal} />
                            </div>
                        </div>) : noFixedPartModals.has(modalContent) ? null : (<div className="fixedPart" />)}
                    {(modalContent === ASSING_WORKFLOW_VIEW) ? (
                        <div key='action' className="doneButtonRow">
                            <div className="doneButton">
                                <ActionButton buttonText="Done" buttonAction={handleAssignTo} />
                            </div>
                        </div>) : noFixedPartModals.has(modalContent) ? null : (<div className="fixedPart" />)}
                </div>
            </div>)
        );
    }

    return (
        renderModal()
    );
};


